module.exports = __webpack_public_path__ + "static/media/2effbe7b-a82b-4592-a071-93b03cd1c7ce_1.ef1ef8d1b50aaf6b071e75f66db406ea.7639bc78.jpeg";